import { IconProps } from "../../utils/global-types/global-types";

const AvailabilityIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M15.145 8.019s.59-2.735-2.82-3.106c0 0 .402-.687 2.05-.897 0 0-1.553-1.899-4.112.092C9.043 1.105 6.75 1.973 6.75 1.973c1.322 1.005 1.325 1.802 1.325 1.802C4.938 2.392 4.08 5.054 4.08 5.054c2.01-.618 3.794.547 3.794.547-4.751-.08-3.087 4.235-3.087 4.235C6.969 6.552 9.45 7.144 9.45 7.144s2.445.727 2.692 4.663c0 0 3.599-2.906-.556-5.212 0 0 2.129-.116 3.56 1.424"
      ></path>
      <path
        fill="currentColor"
        d="M7.172 14.156q.005-.058.012-.115.11-.825.31-1.631a14.8 14.8 0 0 1 1.892-4.422 2 2 0 0 0-.143-.064 2 2 0 0 0-.263-.018c-.223 0-.512.03-.844.129-.113.168-.229.333-.335.503a18 18 0 0 0-.866 1.538 16 16 0 0 0-1.383 4.038c-1.958.144-2.737.997-2.737 2.03h6.69c.001-.96-.67-1.762-2.333-1.988"
      ></path>
    </svg>
  );
};

export default AvailabilityIcon;
